<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-header" i18n="deleteAddresses">Delete Saved Addresses</h3>
    <button
      type="button"
      class="close"
      attr.aria-label="Close"
      ngbAutoFocus
      (click)="activeModal.dismiss('Cross click')"
    >
      <span aria-hidden="true"
        ><i class="ico-cancel modal_exit_cross" id="delete_Saved_Addresses_Modal_Exit_Button"></i
      ></span>
    </button>
  </div>
  <div class="modal-body">
    @for (address of addressList; track address; let i = $index) {
      <div class="flex-row-container address_row">
        <span id="savedAddress-{{ i }}"
          >{{ address.House }} {{ address.Street }} {{ address.Town }} {{ address.PostCode }}</span
        >
        <section (mouseleave)="tt.close()" class="container">
          @if (!address.Company && !address.Office) {
            <i
              i18n-ngbTooltip
              ngbTooltip="Remove address"
              id="remove_Address_Button_{{ i }}"
              attr.aria-label="Remove address {{ address.House }} {{ address.Street }} {{
                address.Town
              }} {{ address.PostCode }}"
              (click)="removeAddress(address, $event)"
              role="button"
              #tt="ngbTooltip"
              (mouseenter)="tt.open()"
              (focus)="tt.open()"
              (blur)="tt.close()"
              tabindex="0"
              class="light-color-warning ico-cancel"
              ><span class="visuallyhidden">Remove address</span>
            </i>
          }
          @if (address.Company || address.Office) {
            <i
              i18n-ngbTooltip
              ngbTooltip="Cannot remove address - address is set at company or office level"
              attr.aria-label="Cannot remove address - address is set at company or office level"
              #tt="ngbTooltip"
              (mouseenter)="tt.open()"
              (focus)="tt.open()"
              (blur)="tt.close()"
              class="ico-info"
              ><span class="visuallyhidden"
                >Cannot remove address - address is set at company or office level</span
              >
            </i>
          }
        </section>
      </div>
    }
  </div>
</div>
